import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

import useStyles from './makeStyles';

const Validation = ({ children, errors, name, clearError, showMessage }) => {
  const classes = useStyles();

  const showError = errors[name] && showMessage;

  return (
    <div>
      {React.Children.map(children, (child) => {
        const childOnChange = child.props.onChange;
        return React.cloneElement(child, {
          onChange: (e) => {
            if (childOnChange) {
              childOnChange(e);
            }
            if (errors[name] && errors[name].type === 'backend') {
              clearError(name);
            }
          },
        });
      })}
      {showError && (
        <div className={`${classes.errorText} error-text`}>{i18n.t(errors[name].message)}</div>
      )}
    </div>
  );
};

Validation.propTypes = {
  children: PropTypes.element.isRequired,
  name: PropTypes.string,
  errors: PropTypes.shape({}),
  clearError: PropTypes.func,
  showMessage: PropTypes.bool,
};

Validation.defaultProps = {
  name: '',
  errors: {},
  clearError: () => {},
  showMessage: true,
};

export default Validation;
